export default {
    INTERNAL: 'internal',
    CUSTOMER: 'customer',
}
